import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-sidenavigation',
  templateUrl: './layout-sidenavigation.component.html',
  styleUrls: ['./layout-sidenavigation.component.scss']
})
export class LayoutSidenavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
